import { isEmptyObject } from '@common/utils';

export const getNewCompanyEventProperties = (values) => {
  const addressAux = { ...values.addresses[0] };
  delete addressAux.phone;
  delete addressAux.type;

  return {
    address: !isEmptyObject(addressAux),
    description: !!values.description && values.description !== '',
    erp_id: !!values.erp && values.erp !== '',
    phone: !!values.addresses[0].phone && values.addresses[0].phone !== '',
    tax_id: !!values.tax && values.tax !== '',
    trade: values.trade != null,
    website: !!values.website && values.website !== '',
  };
};
